import { request } from '../api/reduxRequest';
import type { CategoryValue, JobValue, LocationValue, LovValue, PersonelValue } from '../utils/common';

export const getMenuItems = async () => {
  try {
    const response = await request({
      method: 'GET',
      url: '/platform/common/menu',
    });

    if (response && response.data) {
      const data = response.data;
      //console.log("Menu size (bytes):", new Blob([JSON.stringify(data)]).size);
      return data;
    }
  } catch (error) {
    console.error('Menu items could not be fetched:', error);
    throw error;
  }
};

export const getLovItems = async (): Promise<LovValue[]> => {
  try {
    const response = await request({
      method: 'GET',
      url: '/platform/common/lov/getSelectOptionList',
    });

    if (response && response.data) {
      const data = response.data;
      //console.log("LOV size (bytes):", new Blob([JSON.stringify(data)]).size);
      return data as LovValue[];
    }
    return [];
  } catch (error) {
    console.error('Lov items could not be fetched:', error);
    throw error;
  }
};

export const getPersonelItems = async (): Promise<PersonelValue[]> => {
  try {
    const response = await request({
      method: 'GET',
      url: '/platform/common/lov/getPersonelOptionList',
    });

    if (response && response.data) {
      const data = response.data;
      //console.log("Personel size (bytes):", new Blob([JSON.stringify(data)]).size);
      return data as PersonelValue[];
    }
    return [];
  } catch (error) {
    console.error('Personel items could not be fetched:', error);
    throw error;
  }
};

export const getAdminPersonelItems = async (): Promise<PersonelValue[]> => {
  try {
    const response = await request({
      method: 'GET',
      url: '/platform/common/lov/getAdminPersonelOptions',
    });

    if (response && response.data) {
      const data = response.data;
      //console.log("Personel size (bytes):", new Blob([JSON.stringify(data)]).size);
      return data as PersonelValue[];
    }
    return [];
  } catch (error) {
    console.error('Personel items could not be fetched:', error);
    throw error;
  }
};

export const getLocationItems = async (): Promise<LocationValue[]> => {
  try {
    const response = await request({
      method: 'GET',
      url: '/platform/common/lov/getLocationOptionList',
    });

    if (response && response.data) {
      const data = response.data;
      //console.log("Location size (bytes):", new Blob([JSON.stringify(data)]).size);
      return data as LocationValue[];
    }
    return [];
  } catch (error) {
    console.error('Locaiton items could not be fetched:', error);
    throw error;
  }
};

export const getCategoryItems = async (): Promise<CategoryValue[]> => {
  try {
    const response = await request({
      method: 'GET',
      url: '/platform/common/lov/getCategoryOptionList',
    });

    if (response && response.data) {
      const data = response.data;
      //console.log("Location size (bytes):", new Blob([JSON.stringify(data)]).size);
      return data as CategoryValue[];
    }
    return [];
  } catch (error) {
    console.error('Category items could not be fetched:', error);
    throw error;
  }
};

export const getJobItems = async (): Promise<JobValue[]> => {
  try {
    const response = await request({
      method: 'GET',
      url: '/platform/common/lov/getJobOptionList',
    });

    if (response && response.data) {
      const data = response.data;
      //console.log("Location size (bytes):", new Blob([JSON.stringify(data)]).size);
      return data as JobValue[];
    }
    return [];
  } catch (error) {
    console.error('Category items could not be fetched:', error);
    throw error;
  }
};